/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { UserStatisticsService } from './services/user-statistics.service';
import { UserService } from './services/user.service';
import { NewsFeedService } from './services/news-feed.service';
import { ProfileService } from './services/profile.service';
import { ProfileInvitationService } from './services/profile-invitation.service';
import { EmailVerificationService } from './services/email-verification.service';
import { ProfileAnalyticsService } from './services/profile-analytics.service';
import { ProfileSubscriptionService } from './services/profile-subscription.service';
import { ProfileSubscriptionManagementService } from './services/profile-subscription-management.service';
import { AffiliatedGroupManagementService } from './services/affiliated-group-management.service';
import { ProfileAwardService } from './services/profile-award.service';
import { ProfileFileService } from './services/profile-file.service';
import { ProfileReportService } from './services/profile-report.service';
import { PurchaseService } from './services/purchase.service';
import { ProfileCertificationService } from './services/profile-certification.service';
import { ProfileIdeaService } from './services/profile-idea.service';
import { ProfileAffiliatedService } from './services/profile-affiliated.service';
import { ProfileNewsletterService } from './services/profile-newsletter.service';
import { ProfileCommitmentService } from './services/profile-commitment.service';
import { ActivityService } from './services/activity.service';
import { ActivityGalleryService } from './services/activity-gallery.service';
import { ImpactService } from './services/impact.service';
import { AwardsService } from './services/awards.service';
import { DataAnalyticsService } from './services/data-analytics.service';
import { SearchService } from './services/search.service';
import { MediaService } from './services/media.service';
import { ConfigurationService } from './services/configuration.service';
import { MailChimpService } from './services/mail-chimp.service';
import { FroalaService } from './services/froala.service';
import { TranslateContentService } from './services/translate-content.service';
import { DummyWorkaroundService } from './services/dummy-workaround.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UserStatisticsService,
    UserService,
    NewsFeedService,
    ProfileService,
    ProfileInvitationService,
    EmailVerificationService,
    ProfileAnalyticsService,
    ProfileSubscriptionService,
    ProfileSubscriptionManagementService,
    AffiliatedGroupManagementService,
    ProfileAwardService,
    ProfileFileService,
    ProfileReportService,
    PurchaseService,
    ProfileCertificationService,
    ProfileIdeaService,
    ProfileAffiliatedService,
    ProfileNewsletterService,
    ProfileCommitmentService,
    ActivityService,
    ActivityGalleryService,
    ImpactService,
    AwardsService,
    DataAnalyticsService,
    SearchService,
    MediaService,
    ConfigurationService,
    MailChimpService,
    FroalaService,
    TranslateContentService,
    DummyWorkaroundService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
